import { render, staticRenderFns } from "./WorkspaceGraphDataTableModal.vue?vue&type=template&id=9596c696&scoped=true"
import script from "./WorkspaceGraphDataTableModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceGraphDataTableModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGraphDataTableModal.vue?vue&type=style&index=0&id=9596c696&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9596c696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9596c696')) {
      api.createRecord('9596c696', component.options)
    } else {
      api.reload('9596c696', component.options)
    }
    module.hot.accept("./WorkspaceGraphDataTableModal.vue?vue&type=template&id=9596c696&scoped=true", function () {
      api.rerender('9596c696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGraphDataTableModal.vue"
export default component.exports